const timeout = 301;
const state = {
  linked: false,
  sec30: false,
  message: [],
  timer: {
    remainingTime: timeout
  }
};
const getters = {
  remainingTime(state) {
    return state.timer.remainingTime;
  }
};

const mutations = {
  linkedChange(state, truth) {
    state.linked = truth;
  },
  sec30set(state, truth) {
    state.sec30 = truth;
  },
  messagePush(state, mObj) {
    /// if mObj.text contain imgur
    /// then mObj.image = imgur url
    /// and content view need to check if exists
    /// render by <img> tag
    const imgurPattern = /[http|https]+:\/{2}i\.imgur\.com\/\w+\.\w{3,4}/;
    let result = mObj.text.match(imgurPattern);
    if (result !== null) mObj['image'] = result[0];

    state.message.push(mObj);
  },
  messageSplice(state) {
    state.message.splice(0, 1);
  },
  messageInitial(state) {
    state.message = [];
  },
  messageSuccess(state, time) {
    let s = state.message.find(m => m.time === time);
    s.state = 'success';
  },
  clearTimer(state, payload) {
    clearInterval(payload);
    state.timer.remainingTime = timeout;
  },
  remainingMinus(state) {
    state.timer.remainingTime--;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations
};
